import { CheckValueInput } from "@/src/components"
import { Card, CardContent } from "@mui/material"
import { ArrayInput, AutocompleteArrayInput, CheckboxGroupInput, Create, DateInput, Edit, Form, ReferenceArrayInput, ReferenceInput, required, SelectArrayInput, SelectInput, SimpleFormIterator, TextInput, Toolbar, TransformData, useRecordContext, useResourceDefinitions } from "react-admin"
import  jexl from 'jexl';

const actions = ['*', 'list', 'show', 'create', 'edit', 'delete', 'export', 'clone', 'read', 'write'];

// Validation function for JEXL expressions
const validateJexlExpression = (value: string) => {
    if (!value) return undefined; // Optional field
    
    try {
        // Try to parse the expression with jexl
        jexl.compile(value);
        return undefined; // No error
    } catch (error: any) {
        return `Invalid JEXL expression: ${error.message}`;
    }
};

const TenantFields = () => {
    const record = useRecordContext();
    const resources = useResourceDefinitions();
    const resourceNames = Object.keys(resources);
    return (
        <Card>
            <CardContent>
                {record && <TextInput source="id" readOnly />}
                <TextInput source="name" />

                <ReferenceArrayInput source="users" reference="user">
                    <AutocompleteArrayInput label="Users" optionText="email" filterToQuery={(txt) => ({ email: txt })}
                    />
                </ReferenceArrayInput>

                <TextInput 
                    source="matchRule" 
                    fullWidth 
                    validate={validateJexlExpression}
                    helperText='Enter a valid JEXL expression (e.g., landing_domain == "mypapik.de" || landing_domain == "www.mypapik.de")'
                />

                <ArrayInput source="permissions">
                    <SimpleFormIterator inline>
                        <SelectInput source="resource" choices={resourceNames} validate={required()} />
                        <SelectArrayInput source="action" choices={actions.map(action => ({ id: action, name: action }))} />
                        <CheckValueInput label="Tenant Restricted" source="restrict" checkedValue="tenant" />
                        {/* <CheckboxGroupInput source="restrict" choices={[{id:"tenant",name:"Tenant"}]}/> */}
                    </SimpleFormIterator>
                </ArrayInput>
                {record &&
                    <>
                        <DateInput source="createdAt" readOnly />
                        <DateInput source="updatedAt" readOnly />
                    </>
                }
            </CardContent>
            <Toolbar />
        </Card>
    )

}

const transform: TransformData = (data: any) => {
    const permissions = data.permissions;
    permissions.forEach((permission: any) => {
        if (permission.restrict === null) {
            permission.restrict = undefined; //initial form value is always null
        }
    });

    return data;
}

export const TenantEdit = () =>
    <Edit transform={transform}>
        <Form>

            <TenantFields />
        </Form>
    </Edit>

export const TenantCreate = () =>
    <Create transform={transform}>
        <Form sanitizeEmptyValues>
            <TenantFields />
        </Form>
    </Create>
